// Translations
import landing from '../views/landing/translations/de'

// Translation: Login (German)
export default Object.freeze({
	name: '',
	views: { landing }
})
